import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-69061c13"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "菜单管理/总管理", -1));
const _hoisted_3 = {
  class: "filter-list-content"
};
const _hoisted_4 = {
  class: "input-select-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "list-title"
}, "条件：", -1));
const _hoisted_6 = {
  class: "btn-content"
};
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const menuName = ref('');
    // 搜索
    const handleSearch = () => {
      const params = {
        menuName: menuName.value.trim()
      };
      emit('filterSubmit', params);
    };
    // 重置
    const handleReset = () => {
      menuName.value = '';
      emit('filterSubmit', {
        menuName: ''
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input, {
        value: menuName.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => menuName.value = $event),
        placeholder: "输入菜单名称",
        "allow-clear": "",
        style: {
          "width": "220px"
        }
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
        onClick: handleReset
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});